// extracted by mini-css-extract-plugin
module.exports = {"Option":"Option_Option__3wdjM","selected":"Option_selected__1DrdK"};